import { FunnelType } from 'scenes/common/types';

export enum WireConfigName {
  MaintenanceBanner = 'MAINTENANCE_BANNER',
  EffectiveEndDate = 'EFFECTIVE_END_DATE',
}

type WireConfig = {
  isEnabled: boolean;
  ccMaintenance?: boolean;
  productsUnderMaintenance?: FunnelType[];
  effectiveEndDate?: string;
};

export type WireConfigItem = {
  name: WireConfigName;
  config: WireConfig;
};

export type WireConfigResponse = {
  items: WireConfigItem[];
};
